import { Box, Card, Icon } from '@factorialco/deprecated-design-system'

type Props = {
  label: string
  onClick?: () => void
  icon: React.ComponentProps<typeof Icon.Medium>['icon']
  isSelected: boolean
}

const PaymentMethodCard = ({ label, onClick, icon, isSelected = false }: Props) => {
  return (
    <Box
      width="s240"
      borderRadius={{ all: 'abs016' }}
      style={{
        flex: '1',
        width: '50%',
        boxShadow: `${isSelected ? '0 0 0 1px grey1000 inset' : '0 0 0 0px grey000White inset'}`,
      }}
    >
      <Card onClick={onClick}>
        <Card.Eyebrow>
          <Icon.Medium icon={icon} color="grey800" />
        </Card.Eyebrow>
        <Card.Title size="small">{label}</Card.Title>
      </Card>
    </Box>
  )
}

export default PaymentMethodCard
